import { render } from "./BookCardSkeleton.vue?vue&type=template&id=28f45737&scoped=true"
const script = {}

import "./BookCardSkeleton.vue?vue&type=style&index=0&id=28f45737&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f45737"]])

export default __exports__